// extracted by mini-css-extract-plugin
export var divider = "_ni-0";
export var systemMessage = "_ni-1";
export var systemMessageWrapper = "_ni-2";